import Scenario1Part1 from './Scenario1Part1';
import GameManager from '../../cvp-webgames-core/GameManager';
import { constants } from '../../misc/constants';
import BaseScenarioPart from '../../cvp-webgames-core/Scenario/BaseScenarioPart';
import { VideoEnvironmentProps } from '../../cvp-webgames-core/Components/Environments/React/VideoEnvironment';
import { CalmBaseScenario } from '../CalmBaseScenario';
import Scenario1Part2 from './Scenario1Part2';
import Scenario1Part3 from './Scenario1Part3';

export default class Scenario1 extends CalmBaseScenario {
	parts: BaseScenarioPart<CalmBaseScenario>[] = [
		new Scenario1Part1(this, () => {this.goToPart2()}),
		new Scenario1Part2(this, () => {this.goToPart3()}),
		new Scenario1Part3(this, () => {this.goToScenarioEnd()})
	]
	public get totalNumberOfQuestions(): number {
		return 5;
	}

	public getEnvironmentProps(): VideoEnvironmentProps {
		return {
			controls: false,
			autoBlur: true
		};
	}

	public get currentLevel(): number {
		return 0;
    }
	
	constructor(gameManager: GameManager, scenarioName: string) {
		super(gameManager, scenarioName);
	}

	public getParts(): BaseScenarioPart<CalmBaseScenario>[] {
		return this.parts;
	}

	public getSoundPath(fileName: string): string {
		return './assets/audio/scenario1/' + fileName + '.mp3';
	}

	start() {
        this.gameManager.UiManager.createUIInstance(constants.uiNames.SplashScreenUI);
		this.goToPart1();
		// this.showDelegateUIForTesting()
		// this.showNurseStationComputerForTesting();
		// this.showBadgingUIForTesting();
		// this.showEndLevelUIForTesting();
	}

	goToPart1() {
		this.loadPart(constants.scenarios.scenario1.parts.level1Part1.id, () => {
			this.destroyAllUIInstances();
		});
	}

	goToPart2() {
		this.loadPart(constants.scenarios.scenario1.parts.level1Part2.id);
	}

	goToPart3() {
		this.loadPart(constants.scenarios.scenario1.parts.level1Part3.id);
	}

	goToScenarioEnd() {
	}
}